import { useOnClickOutside } from "helpers/useOnClickOutside";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthStatus } from "reducers/auth";
import { selectHeaderMenuOpen, setHeaderMenuOpen } from "reducers/header";
import HeaderMenu from "./HeaderMenu";
import { useGetUserInfo } from "helpers/useGetUserInfo";
import { selectUserInfo } from "reducers/userInfo";

//icons
import Logo from "../../assets/Logo.svg";
import useMedia from "use-media";
import { Link } from "@reach/router";

const MainHeader = () => {
  const dispatch = useDispatch();
  const authStatus = useSelector(selectAuthStatus);
  const isMenuOpen = useSelector(selectHeaderMenuOpen);

  const tablet = useMedia({ maxWidth: 1200 });

  const openHeaderMenu = () => !isMenuOpen && dispatch(setHeaderMenuOpen());

  useGetUserInfo();
  const { userInfo } = useSelector(selectUserInfo);

  const isSignedIn = authStatus === "signed_in";
  return (
    <div className="MainHeader WidthContent">
      <div className="Logo">
        <Link to="/">
          <img src={Logo} alt="Logo" />
        </Link>
      </div>
      {isSignedIn && (
        <>
          <div className="Venue">
            <span>
              {userInfo?.userType === "Manager"
                ? userInfo?.venueUserDetails?.venueName
                : userInfo?.venueGroupUserDetails?.venueGroupName}
            </span>
            <span>{userInfo?.venueUserDetails?.venueLocation}</span>
          </div>
          <div className="User">
            <span>
              {userInfo && `${userInfo?.firstName} ${userInfo?.lastName}`}
            </span>

            <div className="MenuIcon" onMouseDown={() => openHeaderMenu()}>
              <span>
                {`${userInfo?.firstName[0] ?? ""}${userInfo?.lastName[0] ??
                  ""}`}
              </span>
              <HeaderMenu />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MainHeader;
